import { combineReducers } from 'redux';
import searchResultReducer from './search-result';

const settingsProfileReducer = combineReducers({
  searchResult: searchResultReducer,
});

export default settingsProfileReducer;
